import buildTestScoreHistogramChart from '../../utils/buildTestScoreHistogramChart';

export default buildTestScoreHistogramChart;



// WEBPACK FOOTER //
// ./es6/admin-common-js/apps/csv_chart/charts/testcenter/result_users.js